import { SubCustomersRequestStatus } from '../../models/subCustomersRequest';

export const SUB_CUSTOMERS_REQUEST_STATUS_OPTIONS = Object.values(SubCustomersRequestStatus).map((status) => ({
  key: status,
  value: `subCustomersRequests.statuses.${status}`,
}));